
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  withText?: boolean;
}

const Logo = ({ size = 'medium', withText = true }: LogoProps) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-10 h-10'
  };

  const textSizeClasses = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl'
  };

  return (
    <Link to="/" className="flex items-center space-x-2">
      <div className={`relative ${sizeClasses[size]}`}>
        <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-green-600 rounded-lg transform rotate-45"></div>
        <div className="absolute inset-1 bg-white rounded-md dark:bg-gray-900"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-bold text-green-500">T</span>
        </div>
      </div>
      
      {withText && (
        <span className={`font-bold ${textSizeClasses[size]} bg-gradient-to-r from-green-500 to-green-600 bg-clip-text text-transparent`}>
          TreguIm
        </span>
      )}
    </Link>
  );
};

export default Logo;
